// Inline pause tags inserted into AI-avatar scripts.

// Preset pause durations exposed by the "Add a pause" menu, in milliseconds.
export enum PauseDuration {
  EXTRA_WEAK = 250,
  WEAK = 500,
  MEDIUM = 750,
  STRONG = 1000,
  EXTRA_STRONG = 1500,
}

// Build the inline pause tag (Azure SSML break) for a duration in milliseconds.
export const formatPauseTag = (ms: number): string => `<break time='${ms / 1000}s'/>`;
